import React from 'react';
import {
    Chip,
    IconButton,
    Tooltip
} from '@mui/material';
import {
    Edit as EditIcon,
    Delete as DeleteIcon,
    QuizOutlined as QuizIcon,
    Visibility as VisibilityIcon
} from '@mui/icons-material';
import styles from '../AnamnesisTemplates.module.css';

const AnamnesisCard = ({
    template,
    onEdit,
    onDelete,
    onPreview
}) => {
    const questions = JSON.parse(template.questions || '[]');
    const questionCount = questions.length;

    const formatPreview = () => {
        if (questionCount === 0) return 'Nenhuma pergunta cadastrada';
        
        // Show first few questions as preview with line breaks
        const firstQuestions = questions.slice(0, 3).map((q, index) => {
            const questionText = q.label || q.question || q;
            return `${index + 1}. ${questionText}`;
        });
        
        let preview = firstQuestions.join('\n');
        if (questionCount > 3) {
            preview += `\n... e mais ${questionCount - 3} ${questionCount - 3 === 1 ? 'pergunta' : 'perguntas'}`;
        }
        
        return preview;
    };

    return (
        <div className={styles.templateCard}>
            <div className={styles.cardHeader}>
                <h3 className={styles.templateName}>
                    {template.label || 'Anamnese sem título'}
                </h3>
                
                <div className={styles.templateTags}>
                    <Chip
                        label={`${questionCount} ${questionCount === 1 ? 'pergunta' : 'perguntas'}`}
                        size="small"
                        className={`${styles.templateTag} ${styles.questions}`}
                        color="primary"
                        variant="filled"
                        icon={<QuizIcon />}
                    />
                </div>
            </div>

            <div className={styles.templatePreview}>
                <div className={styles.previewContent}>
                    {formatPreview().split('\n').map((line, index) => (
                        <div key={index} style={{ marginBottom: index < formatPreview().split('\n').length - 1 ? '4px' : '0' }}>
                            {line}
                        </div>
                    ))}
                </div>
            </div>

            <div className={styles.cardFooter}>
                <div className={styles.cardActions}>
                    {onPreview && (
                        <Tooltip title="Ver perguntas">
                            <IconButton
                                size="small"
                                onClick={() => onPreview(template)}
                                color="primary"
                            >
                                <VisibilityIcon fontSize="small" />
                            </IconButton>
                        </Tooltip>
                    )}

                    <Tooltip title="Editar anamnese">
                        <IconButton
                            size="small"
                            onClick={() => onEdit && onEdit(template.id)}
                            color="primary"
                        >
                            <EditIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>

                    <Tooltip title="Excluir anamnese">
                        <IconButton
                            size="small"
                            onClick={() => onDelete && onDelete(template.id)}
                            color="error"
                        >
                            <DeleteIcon fontSize="small" />
                        </IconButton>
                    </Tooltip>
                </div>
            </div>
        </div>
    );
};

export default AnamnesisCard;